import { get } from '../axios'

export const taskManageList = params => get('/web/taskManage/list', params)
